<div class="backpage-wrapper">
  <!-- <app-loading-animation
    *ngIf="loading.isLoading$ | async"
  ></app-loading-animation> -->
  <div class="cred-library-content-creator">
    <div class="credential-library-container padding s6 all">
      <div class="header">
        <h1>Subscriptions</h1>
      </div>
      <!-- <app-loading-animation
        *ngIf="loading.isLoading$ | async"
      ></app-loading-animation> -->
      <div class="no-subs" *ngIf="totalRecords === 0">
        <div class="no-subs-content">
          <div class="no-subs-text">
            <p>No subscriptions found.</p>
          </div>
          <div class="no-subs-image">
            <img
              src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
              alt="No subscriptions found"
            />
          </div>
        </div>
      </div>
      <mat-table
        *ngIf="totalRecords > 0"
        #table
        [dataSource]="dataSource"
        matSort
        class="fixed-table"
      >
        <!-- Maxio Subscription ID Column -->
        <ng-container matColumnDef="maxioSubscriptionId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Sub ID</mat-label>
              <input
                matInput
                placeholder="Search Subscription ID"
                (keyup)="applyInputFilter($event, 'maxioSubscriptionId')"
              />
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{
            element.maxioSubscriptionId || "No ID Provided"
          }}</mat-cell>
        </ng-container>

        <!-- Product Column -->
        <ng-container matColumnDef="product">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Product Name</mat-label>
              <input
                matInput
                placeholder="Search Product"
                (keyup)="applyInputFilter($event, 'product')"
              />
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{
            element.product || "No Product Provided"
          }}</mat-cell>
        </ng-container>

        <!-- Property Name Column -->
        <ng-container matColumnDef="propertyName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Property Name</mat-label>
              <input
                matInput
                placeholder="Search Property Name"
                (keyup)="applyInputFilter($event, 'propertyName')"
              />
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{
            element.propertyName || "No Property Name Provided"
          }}</mat-cell>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Status</mat-label>
              <input
                matInput
                placeholder="Search Status"
                (keyup)="applyInputFilter($event, 'status')"
              />
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-chip
              [ngClass]="{
                'chip-active': element.status === 'Active',
                'chip-inactive': element.status === 'Inactive'
              }"
            >
              {{ element.status || "No Status Provided" }}
            </mat-chip>
          </mat-cell>
        </ng-container>

        <!-- Expiry Date Column -->
        <ng-container matColumnDef="expiryDate">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Billing Renewal Date</mat-label>
              <input
                matInput
                placeholder="Search Expiry Date"
                (keyup)="applyInputFilter($event, 'expiryDate')"
              />
            </mat-form-field>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="cell-content">
              <ng-container
                *ngIf="!isOneTimeSubscription(element); else oneTimeTpl"
              >
                <span>
                  {{
                    element.expiryDate
                      ? (element.expiryDate | date: "MM/dd/yyyy")
                      : "No Expiry Date Provided"
                  }}
                </span>
              </ng-container>

              <ng-template #oneTimeTpl>
                <span>Non‑recurring</span>
              </ng-template>
              <button
                mat-icon-button
                color="accent"
                [routerLink]="['/active-subscription']"
                [queryParams]="{ maxioSubId: element.maxioSubscriptionId }"
              >
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <!-- Header Row Definitions -->
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <!-- Data Row Definitions -->
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <!-- Paginator -->
      <mat-paginator
        [length]="totalRecords"
        [pageSize]="itemsPerPage"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
        (page)="onPageChange($event)"
      ></mat-paginator>
    </div>
  </div>
</div>
